module.exports = __webpack_public_path__ + "img/video.f8d8a261.svg";